import React, { lazy } from "react";
import { Route } from "react-router";

import { RouteGuardApplicationRights } from "components/routes/RouteGuardApplicationRights";
import { LazyRouteElement } from "components/routes/LazyRouteElement";
import Layout from "components/layout/Layout";
import { Module } from "./Module";

const IndexLazy = lazy(() => import("./pages/Index").then(module => ({ default: module.Index })));
const CourseAttendeeLazy = lazy(() => import("./components/attendeeViews/Attendees").then((module) => ({ default: module.Attendees })))
const CourseAttendeeEditLazy = lazy(() => import("./components/attendeeViews/AttendeesEdit").then((module) => ({ default: module.AttendeesEdit })));

export function Routes() {
    return (
        <>
            <Route
                key="course-index"
                path="/course/*"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<IndexLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            /> 
            <Route
                key="course-overview-attendees"
                path="/course/overview/:id?/attendees"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<CourseAttendeeLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />
             <Route
                key="course-overview-attendees-edit"
                path="/course/overview/:id?/attendees/edit"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<CourseAttendeeEditLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />
        </> 
    )
}
